package app.smartcoding.realrate.domain.model

import kotlin.jvm.JvmInline

sealed interface Payment {
    @JvmInline
    value class MainPayment(val value: Double) : Payment
    @JvmInline
    value class Insurance(val value: Double) : Payment
    @JvmInline
    value class Fees(val value: Double) : Payment
    @JvmInline
    value class PaymentTotal(val value: Double) : Payment

    @JvmInline
    value class Error(val error: ErrorType) : Payment
}